<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'App',
  mounted() {
    this.$nextTick(() => {
      // const $app = this.$refs.app

      const $app = document.getElementById('app')
      window.addEventListener(
        'resize',
        _.debounce(function () {
          const parentWidth = window.screen.width
          // 计算缩放比例
          const scaleW = parentWidth / 1600

          if (parentWidth < 1400) {
            $app.style.cssText = `
            transform: scale(${scaleW});
            transform-origin: 0 0;
            width: 1600px;
          `
          } else {
            $app.style.cssText = ''
          }
        }),
        200
      )

      if (document.createEvent) {
        var event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, true)
        window.dispatchEvent(event)
      } else if (document.createEventObject) {
        window.fireEvent('onresize')
      }
    })
  },
}
</script>

<style lang="scss">
@media only screen and (max-width: 1400px) {
  html,
  body {
    width: 100%;
    height: 100%;
  }
}
body {
  font-family: Inter, 'Helvetica Neue', Helvetica,'Microsoft YaHei', '微软雅黑', 'PingFang SC', 'Hiragino Sans GB',  Arial, sans-serif;
}

</style>
